import React from 'react';
import S from './FieldRow.styles';
const FieldRow = ({ className, inline = false, split = false, children, ...rest }) => {
    return (React.createElement(S.Container, { className: className, "data-split-row": split, "data-inline-row": inline, ...rest }, children));
};
export default FieldRow;
